import { jsx as _jsx } from "react/jsx-runtime";
import { StreamrNewLogo } from '@streamr/tv-ui';
import { Link } from 'react-router';
import styled from 'styled-components';
export function LogoLink({ to = '/', logoImage = _jsx(StreamrNewLogo, {}), className, }) {
    return (_jsx(LogoLinkRoot, { to: to, className: className, children: logoImage }));
}
const LogoLinkRoot = styled(Link) `
    width: max-content;
    height: var(--tv-LogoLink-height, 3rem);
    display: flex;
    align-items: center;
    gap: var(--tv-LogoLink-gap, 0.75rem);
    text-decoration: none !important;
`;
